module.exports = __webpack_public_path__ + "static/media/subHeaderBg.d62ee071.jpg";